export default function isTruthy<T>(value: T): value is NonNullable<T> {
  return !!value;
}
